import content from "./policiesContent.people-only-20261102-privacy16.json";

// Approved policy version metadata. Content bodies come verbatim from
// the versioned People-only pack approved by the founder on 2 November 2026.
// Version immutability: to change wording, publish a NEW version (bump `version`
// + `last_updated`); do not silently edit an already-published version.
export const POLICY_VERSION = "1.4";
export const EFFECTIVE_DATE = "2 November 2026";
export const LAST_UPDATED = "2 November 2026";

const META = {
  1:  { slug: "privacy-policy", route: "/privacy", category: "Privacy & Data", order: 1,
        version: "1.2", last_updated: "September 2026",
        description: "How Orrbbit collects, uses, discloses, stores and protects your personal information." },
  2:  { slug: "terms-of-service", route: "/terms", category: "Platform Terms", order: 8,
        version: "1.2", last_updated: "September 2026", status: "Draft — Under Legal Review",
        description: "The agreement governing your access to and use of Orrbbit." },
  3:  { slug: "community-guidelines", route: "/community-guidelines", category: "Safety & Community", order: 2,
        version: "1.1", last_updated: "September 2026",
        description: "The standards that keep Orrbbit authentic, respectful and safe." },
  4:  { slug: "safety-centre-policy", route: "/safety", category: "Safety & Community", order: 1,
        image: "cafe-calm-conversation",
        version: "1.2", last_updated: "September 2026",
        description: "Our safety commitments, tools and guidance for using Orrbbit." },
  5:  { slug: "location-radar-privacy-notice", route: "/location-privacy", category: "Privacy & Data", order: 2,
        version: "1.2", last_updated: "September 2026",
        description: "How location and Radar work, and how your location privacy is protected." },
  6:  { slug: "child-safety-standards", route: "/child-safety", category: "Safety & Community", order: 5,
        description: "Our zero-tolerance standards against child sexual abuse and exploitation." },
  7:  { slug: "moderation-reports-appeals", route: "/moderation-appeals", category: "Safety & Community", order: 3,
        description: "How content is moderated, how to report, and how to appeal decisions." },
  8:  { slug: "professional-services-disclaimer", route: "/professional-services", category: "Platform Terms", order: 11,
        version: "1.1", last_updated: "Pending legal review", status: "Draft — Under Legal Review",
        description: "Important disclaimers about professionals discovered through Orrbbit." },
  9:  { slug: "professional-verification", route: "/professional-verification", category: "Platform Terms", order: 10,
        version: "1.2", last_updated: "September 2026", status: "Draft — Under Legal Review",
        description: "What professional verification means — and what it does not." },
  10: { slug: "account-deletion-data-retention", route: "/deletion-policy", category: "Privacy & Data", order: 5,
        version: "1.1", last_updated: "September 2026",
        description: "How account deletion works and how long data is retained." },
  11: { slug: "copyright-ip", route: "/copyright", category: "Platform Terms", order: 13,
        description: "How to report copyright and intellectual property infringement." },
  12: { slug: "support-complaints", route: "/support-policy", category: "Support", order: 14,
        description: "How to get support, raise complaints and what to expect." },
  13: { slug: "cookie-policy", route: "/cookies", category: "Privacy & Data", order: 6,
        version: "1.1", last_updated: "September 2026",
        description: "How Orrbbit uses cookies and similar technologies." },
  14: { slug: "payments-refunds", route: "/refunds", category: "Payments", order: 12,
        title: "Current Free Access, Previous Purchases & Refunds",
        description: "Current free People access and historical purchase, cancellation and refund obligations." },
  15: { slug: "photo-verification-biometric-privacy", route: "/photo-verification", category: "Privacy & Data", order: 3,
        version: "1.0", last_updated: "September 2026", status: "Draft — Owner Review",
        description: "How Photo Verification works and how verification images are handled." },
  16: { slug: "ai-automated-features", route: "/ai-transparency", category: "Privacy & Data", order: 4,
        version: "1.0", last_updated: "September 2026", status: "Draft — Owner Review",
        description: "Where automated and AI-assisted systems operate at Orrbbit." },
  17: { slug: "professional-terms", route: "/professional-terms", category: "Platform Terms", order: 9,
        version: "1.0", last_updated: "September 2026", status: "Draft — Under Legal Review",
        description: "Terms for professionals listing services through Orrbbit." },
  18: { slug: "business-terms", route: "/business-terms", category: "Platform Terms", order: 11,
        version: "1.0", last_updated: "September 2026", status: "Draft — Under Legal Review",
        description: "Terms for businesses using Orrbbit Business features." },
  19: { slug: "event-meetup-spot-terms", route: "/event-meetup-terms", category: "Platform Terms", order: 12,
        version: "1.0", last_updated: "September 2026", status: "Draft — Under Legal Review",
        description: "Terms for personal, public, approval-required and business events, plus Meetup Spots." },
  20: { slug: "age-eligibility", route: "/age-eligibility", category: "Safety & Community", order: 4,
        version: "1.0", last_updated: "September 2026",
        description: "Orrbbit's 18+ age requirement and how it is enforced." },
};

const allPolicies = content
  .map((p) => ({
    id: `policy-${p.num}`,
    num: p.num,
    title: p.title,
    sections: p.sections,
    version: "1.3",
    effective_date: "24 October 2026",
    last_updated: "24 October 2026",
    active: ![8,9,17].includes(p.num),
    status: "Owner Review Draft",
    ...META[p.num],
    title: p.title,
    version: p.version,
    last_updated: p.last_updated,
    effective_date: p.effective_date,
    status: p.status,
  }))
  .sort((a, b) => a.order - b.order);

export const policies = allPolicies.filter(p=>p.active);
export const getPolicyBySlug = (slug) => allPolicies.find((p) => p.slug === slug);
export const getPolicyByRoute = (route) => allPolicies.find((p) => p.route === route);
export const categories = ["Privacy & Data", "Safety & Community", "Platform Terms", "Payments", "Support"];

